

import logger from 'src/utils/logger/logger';

class Chunker {
    constructor(data, quantity) {
        if (!Array.isArray(data)) {
            throw new Error('chunker source is not an array');
            return false;
        }

        this.data = data.map((item,idx) => {
            if(typeof item === 'object'){
                item.idx_temp = idx;
            }
            return item;
        });
        this.index = data.length - 1;
        this.length = data.length;

        this.quantity = quantity;
    }


    current() {
        if(Array.isArray(this.data)){
            const tmp = [...this.data];
            const startArray = tmp.slice(this.index, this.index + this.quantity);
            const endArray = this.quantity + this.index > this.length ? tmp.slice(0, this.quantity + this.index - this.length) : 0;
            return {
                "idx": this.index,
                "quantity": this.quantity,
                "items": [...startArray, ...endArray]
            };
        }
    }

    getIndex() {
        return this.index;
    }

    getElementByIdx(index) {
        logger.debug('getElementByIdx desdew Chunker', index, this.data);
        return this.data.find(item => item.episode_number === index);
    }

    setIndex(number){
        this.index =
            number < 0 ? this.length - 1 :
            number > this.length - 1 ? 0 :
            number;
    }

    moveCarouselAndFocus = (index, elements) => {
        let targetElement = null;

        for (let i = 0; i < elements.length; i++) {
            const element = elements[i];

            if (parseInt(element.episode_number) === index) {
                targetElement = element;
                break;
            }
        }

        if (targetElement) {
            const createTargetElement = targetElement;
            const newElement = document.createElement('div');

            //* Asigna el contenido al nuevo elemento
            newElement.textContent = createTargetElement.episode_number;

            //* Establece el foco en el nuevo elemento
            newElement.focus();
        }
    }

    loadElements(index, elements) {
        //* Implementacion de la lógica para cargar los elementos faltantes en el carrusel
        //* Array con los nuevos elementos cargados
        const newElements = elements;

        //* Agrega los nuevos elementos a this.data
        this.data.splice(index, 0, ...newElements);

        return this.length = this.data.length;
    }

    moveToVisibleElement(index, elements) {
        let currentIndex = index;
        let element = this.getElementByIdx(currentIndex);

        while (element && !this.isElementVisible(element)) {
            currentIndex++;
            element = this.getElementByIdx(currentIndex);
        }

        if (element) {
            this.setIndex(currentIndex);
            this.moveCarouselAndFocus(currentIndex);
        } else {
            //* El elemento no está visible en el carrusel
            //* Se realiza la lógica correspondiente cuando el elemento no está en el DOM visible
            logger.debug('El elemento no está visible en el carrusel moveToVisibleElement', currentIndex);
            this.setIndex(currentIndex);
            this.moveCarouselAndFocus(currentIndex, elements);
        }
    }

    isElementVisible(element) {
        //* Devuelve true si el elemento es visible, de lo contrario, devuelve false
        logger.debug('isElementVisible desdew Chunker', element);
    }

    reset() {
        this.setIndex(0);
        return;
    }
};

export default Chunker;



// WEBPACK FOOTER //
// ./src/components/EpisodeSelection/components/Chunker.js